import { color } from "@my/util";
import { YStack } from "tamagui";
import { SimpleText } from "../bento-controlled/elements/texts/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const PriorityBadge = ({
  priority,
  omitPriorityText,
  containerProps,
  slim
}) => {
  const [backgroundColor, textColor] = priority === "High" ? [color.opaqueRed, color.lightRed] : ["Moderate", "Medium"].includes(priority) ? ["#ffffcc", "#a5642a"] : ["rgb(227 227 227)", "#636363"];
  return /* @__PURE__ */jsx(YStack, {
    borderRadius: 10,
    paddingHorizontal: slim ? 5 : 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor,
    height: slim ? 25 : 40,
    marginLeft: 10,
    width: 95,
    ...containerProps,
    children: /* @__PURE__ */jsxs(SimpleText, {
      color: textColor,
      fontSize: 12,
      numberOfLines: 2,
      "$platform-native": {
        width: 70
      },
      textAlign: "center",
      fontWeight: "700",
      style: {
        lineHeight: 16
      },
      children: [priority, omitPriorityText ? "" : " Priority"]
    })
  });
};
export { PriorityBadge };
//# sourceMappingURL=misc.mjs.map
